import React from "react";

// Estende os atributos de uma div e exige que o filho seja um ReactElement (como especificado no MUI)
export interface ListItemAvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactElement;
}

export default function ListItemAvatar({
  children,
  className = "",
  ...props
}: ListItemAvatarProps): JSX.Element {
  return (
    <div
      // min-w-[56px] replica o comportamento padrão do MUI para alinhar ícones/avatares em listas
      // flex-shrink-0 garante que o avatar não seja espremido se o texto ao lado for muito longo
      className={`min-w-[56px] flex-shrink-0 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}